<template>
  <div :class="$style.containerForm">
    <ModalCI
    @disable="(vl) => modalCi = vl"
    :showModal="modalCi"/>
    <Modal :statusCode="codeError"
    :type="'create'"
    @disable="(vl) => modalShow = vl"
    :showModal="modalShow"/>
    <ModalCreated
    @disable="(vl) => modalCreated = vl"
    :showModal="modalCreated"/>
    <div v-show="creationSteps.firstStep">
      <div :class="$style.containerText">
        <div :class="$style.containerTexth">
          <PdsTexting format="h1" role="banner">
            Crea tu cuenta
          </PdsTexting>
        </div>
        <div :class="$style.containerTextSubh">
          <PdsTexting :class="$style.textSubh" light format="body">
            Ingresa tus datos de beneficiario para validarlos.
            Si eres beneficiario de m&aacute;s de una pensión de sobrevivencia en Cuprum,
            s&oacute;lo debes crear un usuario para tener acceso a toda la informaci&oacute;n.
          </PdsTexting>
        </div>
        <hr :class="$style.hLine">
      </div>
      <div :class="$style.input">
        <Input
          id="rutCliente"
          label="Ingresa tu RUT de beneficiario"
          aria-label="Ingresa tu RUT de beneficiario. Campo de texto obligatorio."
          @error="(err) => error.rutClient = err"
          @data="writeRut"
          maxlength="12"
          required
          typeinput="rut"
        />
      </div>
      <div :class="$style.input">
        <Input
          id="numSerieCliente"
          label="Nº de serie de tu cédula de identidad"
          aria-label="Ingresa el número de serie de tu cédula de identidad,
          campo de texto obligatorio."
          required
          @error="(err) => error.serialNumber = err"
          @data="writeSerialNumber"
          typeinput="numeroSerie"
        />
      </div>
      <div :class="$style.linkModal" @click="() => modalCi = true">
        <PdsLink
          text="¿Dónde encuentro esto?"
          aria-label="¿Dónde se encuentra el número de serie de mi cédula de identidad?, enlace."
          link="javascript:;"
          />
      </div>
      <div :class="$style.containerSubForm">
        <VueRecaptcha
          language="es-419"
          :class="$style.recaptchaForeign"
          :sitekey="captchaSiteKey"
          :loadRecaptchaScript="true"
          @verify="onCaptchaVerify"
          @expired="onCaptchaExpired"
        />
        <PdsButton
          label="Comenzar"
          aria-label="Comenzar con la validación, botón."
          role=primary
          :class="$style.button"
          @click="nextStep(1)"
          :disabled="!validateFirstStep || !captchaConfirmationCode"
        />
        <div @click="pushBack()">
          <PdsLink
          link="javascript:;"
          aria-label="Regresar al inicio, enlace."
          text="Regresar al inicio"
          />
        </div>
        <Loading v-if="load"/>
      </div>
    </div>
    <div v-show="creationSteps.secondStep">
      <div :class="$style.containerText">
        <div :class="$style.containerTexth">
          <PdsTexting format="h1">
            ¡Hola {{userName}}!
          </PdsTexting>
        </div>
        <div :class="$style.containerTextSubh">
          <PdsTexting format="body">
            Ingresa tus datos de contacto y crea tu acceso.
          </PdsTexting>
        </div>
        <hr :class="$style.hLine">
      </div>
      <div :class="$style.input">
        <Input
          id="emailCliente"
          label="Ingresa tu correo electrónico"
          aria-label="Ingresa tu correo electrónico, campo de texto obligatorio."
          required
          maxlength="50"
          @error="(err) => error.email = err"
          @data="writeEmail"
          typeinput="email"
        />
      </div>
      <div :class="$style.input">
        <Input
          id="reEmailCliente"
          label="Repite tu correo electrónico"
          aria-label="Repite tu correo electrónico, campo de texto obligatorio."
          required
          maxlength="50"
          @error="(err) => error.reemail = err"
          @data="writeReEmail"
          typeinput="email"
          :errorMessage=this.error.differentEmails
        />
      </div>
      <div :class="$style.input">
        <label for="telefonoCliente">
          Ingresa tu teléfono móvil
        </label>
        <div :class="$style.telInput">
          <PdsTexting :class="$style.telInputPrefix" format="body3">
            +(56) 9
          </PdsTexting>
          <Input
            id="telefonoCliente"
            aria-label="Ingresa tu teléfono móvil"
            required
            maxlength="8"
            @error="(err) => error.cellphone = err"
            @data="writeCellphone"
            typeinput="tel"
            :class="$style.telInputNumber"
          />
        </div>
      </div>
      <div :class="$style.input">
        <label for="reTelefonoCliente">
          Repite tu teléfono móvil
        </label>
        <div :class="$style.telInput">
          <PdsTexting :class="$style.telInputPrefix" format="body3">
            +(56) 9
          </PdsTexting>
          <Input
            id="reTelefonoCliente"
            aria-label="Repite tu teléfono móvil"
            required
            maxlength="8"
            @error="(err) => error.recellphone = err"
            @data="writeReCellphone"
            typeinput="tel"
            :class="$style.telInputNumber"
            :errorMessage=this.error.differentCellphones
          />
        </div>
      </div>
      <div :class="$style.containerSubForm">
        <div>
          <PdsCheckbox
          id="conocimientoDatos"
          label="Tomo conocimiento que estos datos serán utilizados
          como datos de contacto con Cuprum AFP, y serán ocupados
          para fines previsionales."
          aria-label="Información sobre el uso de tus datos:
          Tomo conocimiento que estos datos serán utilizados
          como datos de contacto con Cuprum AFP, y serán
          ocupados para fines previsionales.
          No seleccionado, casilla de verificación obligatoria.
          Estas en un elemento de tipo casilla de verificación.
          Para seleccionar o anular la selección de esta opción,
          pulsa control, opción, espacio.
          Para salir de esta área web pulsa control,
          opcion, mayusculas flecha arriba."
          valueSelector="true"
          v-model="data.dataUseCheck"
          />
        </div>
        <PdsButton
          label="Continuar"
          aria-label="Continuar, botón."
          role=primary
          :class="$style.button"
          @click="nextStep(2)"
          :disabled="!validateSecondStep"
        />
      </div>
    </div>
    <div v-show="creationSteps.thirdStep">
      <CreatePasswordInput
        :title="userName"
        subTitle="Ahora crea tu clave de acceso."
        @data="(pass) => createAccount(pass)"
        :name="userName"
        :typeAccount="'Crear mi cuenta'"
        :rut="data.rutClient !== null ? data.rutClient.value.rut : data.rutClient"
        titleBtn="Crear mi cuenta"
      />
    </div>
  </div>
</template>

<script>
import PdsButton from '@vue-pds/button';
import PdsLink from '@vue-pds/link';
import Input from '@/components/Input';
import VueRecaptcha from 'vue-recaptcha';
import PdsCheckbox from '@vue-pds/checkbox';
import PdsTexting from '@vue-pds/texting';
import _ from 'lodash';
import CreatePasswordInput from '@/components/CreatePasswordInput';
import { capitalize } from '@/includes/formatters';
import { mapActions, mapState } from 'vuex';
import types from '@/constants/types';
import Loading from '@/components/Loading';
import Modal from '@/components/Modal';
import ModalCI from '@/components/ModalCI';
import ModalCreated from '@/components/ModalCreated';
import gtmRegister from '@/functions/analitics';
import constantsAnalytics from '@/config/constantsAnalytics';

export default {
  name: 'CreatePasswordForm',
  components: {
    PdsLink,
    PdsButton,
    Input,
    VueRecaptcha,
    PdsCheckbox,
    PdsTexting,
    CreatePasswordInput,
    Loading,
    Modal,
    ModalCI,
    ModalCreated,
  },
  data() {
    return {
      load: false,
      personalData: null,
      verificationToken: '',
      data: {
        rutClient: null,
        password: null,
        repassword: null,
        serialNumber: null,
        email: null,
        reemail: null,
        cellphone: null,
        recellphone: null,
        dataUseCheck: false,
      },
      modalCi: false,
      modalCreated: false,
      modalShow: false,
      codeError: 200,
      error: {
        rutClient: null,
        password: null,
        repassword: null,
        serialNumber: null,
        email: null,
        reemail: null,
        cellphone: null,
        recellphone: null,
        differentEmails: null,
        differentCellphones: null,
      },
      captchaConfirmationCode: null,
      userName: '',
      creationSteps: {
        firstStep: true,
        secondStep: false,
        thirdStep: false,
      },
    };
  },
  methods: {
    ...mapActions({
      postCreateBeneficiary: types.async.POST_CREATE_BENEFICIARY,
      login: types.async.LOGIN,
      saveUser: types.actions.SAVE_USER,
      saveToken: types.actions.SAVE_TOKEN,
      verifyCI: types.actions.GET_VERIFY_CI,
      validateBeneficiary: types.async.GET_VALIDATE_BENEFICIARY,
      verifyBeneficiary: types.async.GET_VERIFY_BENEFICIARY,
      beneficiaryData: types.async.DATA_BENEFICIARY,
    }),
    writeRut(rut) {
      this.data.rutClient = rut;
    },
    writeSerialNumber(serial) {
      this.data.serialNumber = serial;
    },
    writeEmail(email) {
      this.data.email = email;
      this.compareValues('email', email, this.data.reemail);
    },
    writeReEmail(email) {
      this.data.reemail = email;
      this.compareValues('email', this.data.email, email);
    },
    writeCellphone(cell) {
      this.data.cellphone = cell;
      this.compareValues('number', cell, this.data.recellphone);
    },
    writeReCellphone(cell) {
      this.data.recellphone = cell;
      this.compareValues('number', this.data.cellphone, cell);
    },
    onCaptchaVerify(value) {
      this.captchaConfirmationCode = value;
    },
    onCaptchaExpired() {
      this.captchaConfirmationCode = null;
    },
    pushBack() {
      gtmRegister(constantsAnalytics.create.pageindex, this);
      this.$router.push('/');
    },
    compareValues(type, val1, val2) {
      if (type === 'email' && val1 !== null && val2 !== null) {
        this.error.differentEmails = val1.value !== val2.value ? 'Datos no coinciden' : null;
      }
      if (type === 'number') {
        this.error.differentCellphones = val1.value !== val2.value ? 'Datos no coinciden' : null;
      }
    },
    async postVerifyCI() {
      this.load = true;
      const verifyDocument = await this.verifyCI({
        rut: parseInt(this.data.rutClient.value.rut, 10),
        dv: this.data.rutClient.value.dv,
        serialNumber: this.data.serialNumber.value.replace(/\./g, ''),
      });

      this.verificationToken = verifyDocument.data.token;

      const verify = await this.verifyBeneficiary({
        rut: parseInt(this.data.rutClient.value.rut, 10),
        dv: this.data.rutClient.value.dv,
        token: this.verificationToken,
      });

      if (verify.data.registrado === false) {
        this.personalData = await this.beneficiaryData({
          rut: this.data.rutClient.value.rut,
          token: this.verificationToken,
        });

        this.userName = capitalize(this.personalData.data.names, true);
        this.creationSteps.firstStep = false;
        this.creationSteps.secondStep = true;
      }
      this.load = false;
    },
    nextStep(step) {
      if (step === 1) {
        gtmRegister(constantsAnalytics.create.indentify, this);
        this.postVerifyCI();
      }
      if (step === 2) {
        gtmRegister(constantsAnalytics.create.personaldata, this);
        this.creationSteps.secondStep = false;
        this.creationSteps.thirdStep = true;
      }
    },
    async createAccount(pass) {
      this.load = true;
      await this.postCreateBeneficiary({
        token: this.verificationToken,
        rut: this.data.rutClient.value.rut,
        dv: this.data.rutClient.value.dv,
        name: this.userName,
        lastName: `${this.personalData.data.surname} ${this.personalData.data.secondSurname ? this.personalData.data.secondSurname : ''}`,
        email: this.data.email.value,
        mobilePhone: this.data.cellphone.value,
        password: pass.password,
      });

      const personalData = await this.login({
        rut: parseInt(this.data.rutClient.value.rut, 10),
        password: pass.password,
        dv: this.data.rutClient.value.dv,
      });

      await this.saveUser({
        Rut: this.data.rutClient.value.rut,
        Dv: this.data.rutClient.value.dv,
        names: personalData.data.names,
        surname: personalData.data.surname,
        secondSurname: personalData.data.secondSurname,
        clientId: personalData.data.clientId,
      });

      await this.saveToken({
        token: personalData.data.sessionToken,
      });

      await this.validateBeneficiary({
        rut: this.data.rutClient.value.rut,
      });

      gtmRegister(constantsAnalytics.create.createpass, this);

      this.$router.push('/home');
      this.load = false;
    },
  },
  computed: {
    ...mapState({
      postDataBeneficiary: state => state.async[types.actions.POST_CREATE_BENEFICIARY].data || [],
      errorDataBeneficiary: state => state.async[types.actions.POST_CREATE_BENEFICIARY].error,
      errorActive: state => state.async[types.async.LOGIN].loading,
      loginError: state => state.async[types.async.LOGIN].error,
      dataVerifyBeneficiary: state => state.async[types.async.GET_VERIFY_BENEFICIARY].data || [],
      errorVerifyBeneficiary: state => state.async[types.async.GET_VERIFY_BENEFICIARY].error,
      dataVerifyCI: state => state.async[types.async.GET_VERIFY_CI].data || [],
      beneficiaryDataError: state => state.async[types.async.DATA_BENEFICIARY].error,
      errorVerifyCI: state => state.async[types.async.GET_VERIFY_CI].error,
      errorVerifyCiLoading: state => state.async[types.async.GET_VERIFY_CI].loading,
      errorVerifyBeneficiaryLoading:
      state => state.async[types.async.GET_VERIFY_BENEFICIARY].loading,
    }),
    captchaSiteKey() {
      return process.env.VUE_APP_CAPTCHA_SITE_KEY;
    },
    validateFirstStep() {
      const serialNumber = this.data.serialNumber === null ? false
        : (this.data.serialNumber.value !== null && this.data.serialNumber.value !== '');

      let errorSerial = false;
      if (this.data.serialNumber !== null && this.data.serialNumber.value !== null) {
        if (_.startsWith(this.data.serialNumber.value, 'A')) {
          if (this.data.serialNumber.value.length < 10) {
            errorSerial = true;
          }
        }
      }

      if (this.data.serialNumber !== null && this.data.serialNumber.value !== null) {
        if (!_.startsWith(this.data.serialNumber.value, 'A')) {
          if (this.data.serialNumber.value.length < 11) {
            errorSerial = true;
          }
        }
      }

      const rut = this.data.rutClient === null ? false
        : (this.data.rutClient.value !== null && this.data.rutClient.value.rut !== null
        && this.data.rutClient.value.rut !== '' && this.data.rutClient.value !== null
        && this.data.rutClient.value.dv !== null && this.data.rutClient.value.dv !== '');

      const errorRut = this.error.rutClient !== null ? this.error.rutClient.error : true;

      if (serialNumber && rut && !errorSerial && !errorRut) {
        return true;
      }

      return false;
    },
    validateSecondStep() {
      const email = this.data.email === null ? false
        : (this.data.email.value !== null && this.data.email.value !== '');
      const cellphone = this.data.cellphone === null ? false
        : (this.data.cellphone.value !== null && this.data.cellphone.value !== '');
      const dataUseCheck = this.data.dataUseCheck === null ? false
        : this.data.dataUseCheck;
      let errorEmail = this.error.email !== null ? this.error.email.error : false;

      errorEmail = errorEmail && this.error.reemail != null ? this.error.reemail.error
        : errorEmail;

      if (email && this.data.reemail !== null && typeof this.data.reemail !== 'undefined') {
        errorEmail = this.data.email.value !== this.data.reemail.value ? true
          : errorEmail;
      }

      let errorCellphone = false;
      if (cellphone && this.data.recellphone !== null) {
        errorCellphone = this.data.cellphone.value !== this.data.recellphone.value ? true
          : errorCellphone;
      }
      if (email && cellphone && !errorEmail && !errorCellphone && dataUseCheck) {
        return true;
      }
      return false;
    },
  },
  watch: {
    userName(value) {
      if (value !== '') {
        this.load = false;
        this.creationSteps.firstStep = false;
        this.creationSteps.secondStep = true;
      }
    },
    errorDataBeneficiary(val) {
      if ((val.response !== null || val.isAxiosError) && !this.errorActive) {
        this.codeError = val.response ? val.response.status : 0;
        this.modalShow = true;
        this.load = false;
      }
    },
    loginError(val) {
      if ((val.response !== null || val.isAxiosError) && !this.errorActive) {
        this.codeError = val.response ? val.response.status : 0;
        this.modalShow = true;
        this.load = false;
      }
    },
    errorVerifyCI(val) {
      if ((val.response !== null || val.isAxiosError) && !this.errorVerifyCiLoading) {
        this.codeError = val.response ? val.response.status : 0;
        this.modalShow = true;
        this.load = false;
      }
    },
    beneficiaryDataError(val) {
      if ((val.response !== null || val.isAxiosError) && !this.errorVerifyCiLoading) {
        this.codeError = val.response ? val.response.status : 0;
        this.modalShow = true;
        this.load = false;
      }
    },
    errorVerifyBeneficiary(val) {
      if ((val.response !== null || val.isAxiosError) && !this.errorVerifyBeneficiaryLoading) {
        this.codeError = val.response ? val.response.status : 0;
        this.modalShow = true;
        this.load = false;
      }
    },
    dataVerifyBeneficiary(val) {
      if (val !== null) {
        if (val.status === 204) {
          this.modalShow = true;
          this.load = false;
        }
        if (val.data !== null && val.data.registrado !== null) {
          if (val.data.registrado === true) {
            this.modalCreated = true;
            this.load = false;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" module>

.containerForm {
  position: relative;
  width: 600px;
  margin: 0 auto;

  & .containerText {
    padding: 30px 0;

    & .containerTexth {
      font-size: 60px;
    }

    & .containerTextSubh {
      padding: 25px 0;
      font-size: 22px;

      & .textSubh {
        font-weight: lighter;
      }
    }

    & .hLine {
      width: 57px;
      height: 3px;
      margin: 0;
      background: #ffc82e;
      border: 0;
    }
  }

  & .containerSubForm {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;

    & .button {
      align-content: center;
      width: 300px;
      height: 42px;
      padding: 0 110px;
      margin: 20px 0;
      text-align: center;
    }
  }

  & .link {
    border-bottom: 1px solid #0061a0;
  }

  & .telInput {
    display: flex;
    flex-direction: row;

    & .telInputPrefix {
      min-width: 130px;
      padding: 5px 5%;
    }

    & .telInputNumber {
      width: 100%;
    }
  }
}

.linkModal {
  width: 180px;
}

@media (min-width: 500px) and (max-width: 940px) {
  .containerForm {
    width: auto;

    & .containerText {
      & .containerTexth {
        font-size: 50px;
      }
    }
  }
}

@media (max-width: 500px) {
  .containerForm {
    width: auto;

    & .containerText {
      & .containerTexth {
        font-size: 50px;
      }
    }

    & .telInput {
      & .telInputPrefix {
        min-width: 90px;
        padding: 5px 2%;
        font-size: 14px;
      }

      & .telInputNumber {
        width: 100%;
      }
    }
  }
}
</style>
